/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */

/* eslint-disable no-prototype-builtins */
'use es6';
/**
 * TODO:
 * When changing this component's propTypes,
 * update its corresponding .d.ts file. This
 * file is not autogenerated; it is manually
 * maintained.
 *
 * Once this component has been converted to
 * TypeScript, remove this comment.
 * https://hubspot.slack.com/archives/G1WJWMNMQ/p1665775630614649
 */

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Controllable from '../decorators/Controllable';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { createRef, Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import Select from 'react-select-plus';
import devLogger from 'react-utils/devLogger';
import { closest } from '../utils/Dom';
import { getAriaAndDataProps } from '../utils/Props';
import { callIfPossible, sequence } from '../core/Functions';
import SyntheticEvent from '../core/SyntheticEvent';
import { OptionOrGroupType, ValueType } from '../types/OptionTypes';
import { PLACEMENTS } from '../tooltip/PlacementConstants';
import UITypeaheadResultsItem from '../typeahead/results/UITypeaheadResultsItem';
import UILink from '../link/UILink';
import UIControlledPopover from '../tooltip/UIControlledPopover';
import UILoadingSpinner from '../loading/UILoadingSpinner';
import UISearchInput from '../input/UISearchInput';
import MultiSelectValue from './utils/MultiSelectValue';
import UISelectWithButtonAnchor from './internal/UISelectWithButtonAnchor';
import UISelectWithInputAnchor from './internal/UISelectWithInputAnchor';
import lazyEval from '../utils/lazyEval';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import * as customRenderer from '../utils/propTypes/customRenderer';
import { hidden } from '../utils/propTypes/decorators';
import { MIN_MENU_WIDTH } from '../constants/Tether';
import UIButton from '../button/UIButton';
import UIClickable from '../button/UIClickable';
import refObject from '../utils/propTypes/refObject';
import memoizeOne from 'react-utils/memoizeOne';
import { Consumer as FieldsetContextConsumer } from '../context/FieldsetContext';
const {
  Async,
  Creatable,
  stripDiacritics
} = Select;
const SELECT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__selectplus--small'
};
let hasPingedNewRelic = false;
let hasShownDevWarning = false;

const isVirtualized = menuRenderer => menuRenderer && menuRenderer.displayName === 'virtualizedMenuRenderer';

const LoadMoreComponent = ({
  options,
  pagination
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("span", {
      className: "private-form__selectplus--load-more-count",
      children: pagination.length ? I18n.text('salesUI.UISelect.andMore', {
        count: pagination.length - options.length
      }) : ''
    }), /*#__PURE__*/_jsx(UILink, {
      children: I18n.text('salesUI.UISelect.loadMore')
    })]
  });
};

let multiDummyOption;

const getMultiDummyOption = () => {
  multiDummyOption = multiDummyOption || {
    disabled: true,
    dropdownText: I18n.text('salesUI.UISelect.allOptionsSelected'),
    isSpecial: true,
    title: '',
    value: '__MULTI_DUMMY_OPTION__'
  };
  return multiDummyOption;
};

const loadMoreOptionValue = '__LOAD_MORE_OPTION__';

const getLoadMoreOption = ({
  input,
  loadMoreComponent,
  options,
  pagination
}) => {
  return {
    dropdownClassName: 'private-form__selectplus--load-more',
    dropdownText: customRenderer.render(loadMoreComponent, {
      options,
      pagination
    }),
    input,
    isSpecial: true,
    title: '',
    value: loadMoreOptionValue
  };
};

const getIsLoadingOption = () => {
  return {
    disabled: true,
    dropdownClassName: 'private-dropdown__loading',
    dropdownText: /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      size: "sm"
    }),
    isSpecial: true,
    title: '',
    value: '__IS_LOADING_OPTION__'
  };
};

const getInputProps = (autoComplete, disabled, id, searchable, computedAnchorType, handleAutosize, handlePaste, readOnly) => {
  if (disabled || !searchable || computedAnchorType !== 'combined' || readOnly) return {};
  return {
    autoComplete,
    id,
    onAutosize: handleAutosize,
    onPaste: handlePaste
  };
};
/**
 * @param {Object} option The option to determine the checkbox state for
 * @param {*} value The `value` prop
 * @return {Object} { indeterminate, checked }
 */


const getCheckboxState = (option, value) => {
  if (option.getCheckboxState) return option.getCheckboxState(option);
  const isOptionGroup = !!option.options;
  const isSelectAll = isOptionGroup && !!option.selectAll;
  let nestedOptionCount = 0;
  let selectedOptionCount = 0;

  if (isSelectAll) {
    const tabulate = o => {
      if (o.options) {
        o.options.forEach(tabulate);
      } else if (!o.disabled) {
        nestedOptionCount += 1;
        if (Array.isArray(value) && value.includes(o.value)) selectedOptionCount += 1;
      }
    };

    tabulate(option);
  }

  const indeterminate = isSelectAll && 0 < selectedOptionCount && selectedOptionCount < nestedOptionCount;
  const checked = isSelectAll ? nestedOptionCount === selectedOptionCount : !!(Array.isArray(value) && value.includes(option.value));
  return {
    indeterminate,
    checked
  };
};

const makeNewOptionsCache = (optionsCache, options) => {
  const newOptionsCache = Object.assign({}, optionsCache);

  const addOptionToCache = option => {
    newOptionsCache[option.value] = option;
  };

  const addOptionListToCache = optionList => {
    optionList.forEach(option => {
      if (Array.isArray(option.options)) {
        addOptionListToCache(option.options);
      } else {
        addOptionToCache(option);
      }
    });
  }; // Recursively add all options, including those within groups, to the cache.


  addOptionListToCache(options);
  return newOptionsCache;
};

function promptTextCreator(label) {
  return I18n.text('salesUI.UISelect.createOption', {
    label: I18n.SafeString(label)
  });
}
/**
 * "Cleans" an input value. Matches the filter react-select-plus applies to the input passed to `loadOptionsProxy`. (#5289)
 */


function filterInputValue(inputValue, {
  ignoreAccents = true,
  ignoreCase = true
}) {
  // https://github.com/HubSpot/react-select-plus/blob/8ae7465fc9b6b9600a01e4e23de97f2d403fd139/src/Async.js#L155-L163
  let transformedInputValue = inputValue;

  if (ignoreAccents) {
    transformedInputValue = stripDiacritics(transformedInputValue);
  }

  if (ignoreCase) {
    transformedInputValue = transformedInputValue.toLowerCase();
  }

  return transformedInputValue;
}

const getOptionsCache = ({
  options
}, {
  optionsCache
}) => {
  // Cache options provided via props (required for certain async scenarios, and for paste handling)
  if (options) {
    const newOptionsCache = makeNewOptionsCache(optionsCache, options);
    return {
      optionsCache: newOptionsCache
    };
  }

  return null;
};

const getPaginationCache = ({
  cache
}) => {
  // If async caching is disabled, paginationCache should not persist across searches
  if (cache === null || cache === false) {
    return {
      paginationCache: {}
    };
  }

  return null;
};

const getResetOption = ({
  placeholder,
  resetValue
}, {
  resetOption
}) => {
  const newResetOption = {
    buttonText: lazyEval(placeholder),
    dropdownText: lazyEval(placeholder),
    value: resetValue
  };

  if (!(resetOption && resetOption.buttonText === newResetOption.buttonText && resetOption.value === newResetOption.value)) {
    return {
      resetOption: newResetOption
    };
  }

  return null;
};

class UISelectCore extends Component {
  static getDerivedStateFromProps(props, state) {
    const cacheOptions = getOptionsCache(props, state);
    const resetOption = getResetOption(props, state);
    let paginationCache;
    let initiallyOpen;
    let prevOpen;

    if (!state.prevOpen && props.open) {
      paginationCache = getPaginationCache(props);
    } else if (state.prevOpen && !props.open) {
      initiallyOpen = {
        initiallyOpen: false
      };
    }

    if (state.prevOpen !== props.open) {
      prevOpen = {
        prevOpen: props.open
      };
    }

    return Object.assign({}, cacheOptions, {}, resetOption, {}, paginationCache, {}, initiallyOpen, {}, prevOpen);
  }

  constructor(_props) {
    super(_props);
    this.state = {
      controlWidth: 0,
      initiallyOpen: false,
      inputValue: '',
      isLoading: false,
      optionsCache: {},
      paginationCache: {},
      prevOpen: false,
      resetOption: null
    };
    this.popoverRef = /*#__PURE__*/createRef();

    this.optionRendererProxy = option => {
      const {
        optionRenderer,
        optionRendererIgnoresSpecialOptions
      } = this.props;

      if (optionRenderer == null || option.isSpecial && optionRendererIgnoresSpecialOptions) {
        return this.defaultOptionRenderer(option);
      }

      return optionRenderer(option);
    };

    this.defaultValueRenderer = option => {
      const {
        itemComponent,
        valueComponent
      } = this.props;
      return /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
        "aria-invalid": option.invalid,
        itemComponent: valueComponent || itemComponent,
        option: Object.assign({}, option, {
          help: undefined
        }),
        _useButton: false,
        _useDropdownText: false
      }, option.value);
    };

    this.filterOptionsProxy = (options, input, excludeOptions, ...rest) => {
      const {
        anchorType,
        clearable,
        filterOptions,
        ignoreAccents,
        ignoreCase,
        isLoading: isLoadingProp,
        loadMoreComponent,
        multi,
        resetValue,
        value
      } = this.props;
      const {
        isLoading,
        paginationCache,
        resetOption
      } = this.state;
      let filterOptionsFunc;

      if (filterOptions === false) {
        filterOptionsFunc = x => x;
      } else if (typeof filterOptions === 'function') {
        filterOptionsFunc = filterOptions;
      } else {
        filterOptionsFunc = this.getDefaultFilterOptionsFunc();
      }

      const showSelectedOptions = this.areOptionsToggleable({
        anchorType,
        multi
      });
      let filteredOptions = filterOptionsFunc(options, input, showSelectedOptions ? [] : excludeOptions, ...rest);

      if (input.length === 0) {
        // Add multi dummy option, if needed (#1256)
        if (multi && options.length > 0 && filteredOptions.length === 0) {
          filteredOptions = filteredOptions.concat(getMultiDummyOption());
        } // Add resetOption, if needed (#2300)


        if (clearable && !multi && value != null && value !== resetValue) {
          filteredOptions = [resetOption].concat(filteredOptions);
        }
      }

      if (isLoading || isLoadingProp) {
        // Add "Loading..." option, if needed
        filteredOptions = filteredOptions.concat(getIsLoadingOption());
      } else {
        const paginationCacheKey = filterInputValue(input, {
          ignoreAccents,
          ignoreCase
        });
        const pagination = paginationCache[paginationCacheKey]; // Add "Load more" option, if needed (#2031)

        if (pagination && pagination.hasMore) {
          filteredOptions = filteredOptions.concat(getLoadMoreOption({
            input,
            isLoading,
            loadMoreComponent,
            options,
            pagination
          }));
        }
      }

      return filteredOptions;
    };

    this.creatableOnInputChangeProxy = str => {
      const internalCreatableSelect = this.getInternalCreatableSelect();
      const newInputValue = this.handleInputChange(str);
      internalCreatableSelect.inputValue = newInputValue;
      return newInputValue;
    };

    this.handleChange = option => {
      // react-select-plus gives us an option object or null, which we pass to
      // onSelectedOptionChange, but our onChange handler expects just the new value.
      const {
        onChange,
        onSelectedOptionChange,
        value
      } = this.props;
      callIfPossible(onSelectedOptionChange, SyntheticEvent(option));
      let newVal = null;

      if (Array.isArray(option)) {
        newVal = option.reduce((acc, item) => {
          if (item) {
            const {
              value: itemValue
            } = item;
            const i = acc.indexOf(itemValue);

            if (i > -1) {
              acc.splice(i, 1);
            } else {
              acc.push(itemValue);
            }
          }

          return acc;
        }, []);
      } else if (option) {
        newVal = option.value;
      }

      if (newVal !== value) {
        onChange(SyntheticEvent(newVal));
      }
    };

    this.handleInputKeyDown = evt => {
      const {
        anchorType,
        multi,
        onInputKeyDown,
        value
      } = this.props;
      const {
        key
      } = evt;
      callIfPossible(onInputKeyDown, evt);

      if (evt.defaultPrevented) {
        return;
      } // In multi-mode, we need to handle ENTER to allow the focused option to be toggled.


      if (key === 'Enter' && multi && this.getAnchorType({
        anchorType,
        multi
      }) !== 'combined') {
        const internalSelect = this.getInternalSelect();

        if (!internalSelect) {
          return;
        }

        const focusedOption = internalSelect._focusedOption;

        if (!focusedOption) {
          return;
        }

        if (focusedOption.value === loadMoreOptionValue) {
          this.triggerLoadMore();
          return;
        }

        if (focusedOption.isSpecial || focusedOption.clearableValue === false) {
          return;
        }

        const valueToToggle = focusedOption.value;
        const willBeSelected = value.indexOf(valueToToggle) === -1;
        this.toggleMultiValue(valueToToggle, willBeSelected);
        evt.preventDefault();
      }
    };

    this.handleOptionToggle = (option, evt) => {
      const {
        value
      } = this.props;

      if (option.options && option.selectAll) {
        const {
          checked,
          indeterminate
        } = getCheckboxState(option, value);
        this.toggleGroup(option, !checked && !indeterminate);
      } else {
        const valueToToggle = option.value;
        this.toggleMultiValue(valueToToggle, evt.target.checked);
      }
    };

    this.handleClose = evt => {
      const {
        onClose,
        onOpenChange
      } = this.props; // eslint-disable-line react/prop-types

      onOpenChange(SyntheticEvent(false));
      callIfPossible(onClose, evt);
    };

    this.handleOpen = evt => {
      const {
        onOpen,
        onOpenChange
      } = this.props; // eslint-disable-line react/prop-types

      onOpenChange(SyntheticEvent(true));
      callIfPossible(onOpen, evt);
    };

    this.triggerOpen = () => {
      const {
        onOpenChange
      } = this.props;
      onOpenChange(SyntheticEvent(true));
    };

    this.handleInputChange = str => {
      const {
        loadOptions,
        multi,
        onInputChange,
        menuRenderer
      } = this.props;
      callIfPossible(onInputChange, str);
      this.setState({
        inputValue: str
      }); // Handle typing multi values separated by splitRegex.

      if (multi) {
        const splitValues = this.getSplitValuesFromString(str, false);

        if (splitValues.length > 0) {
          this.addMultiValues(splitValues);
          return '';
        }
      } // If the user typed a request that will hit the cache, ignore any pending request.


      if (loadOptions != null) {
        const internalAsyncSelect = this.getInternalAsyncSelect();

        if (internalAsyncSelect != null) {
          if (internalAsyncSelect._cache && internalAsyncSelect._cache.hasOwnProperty(str)) {
            internalAsyncSelect._callback = null;
            this.setState({
              isLoading: false
            });
          }
        }
      } // Ensure row height for virtualized menu renderer is recomputed


      if (isVirtualized(menuRenderer)) {
        if (this._virtualizedMenuRenderer) this._virtualizedMenuRenderer.recomputeRowHeights();
      }

      return str;
    };

    this.handleInputValueChange = evt => {
      const {
        onInputValueChange
      } = this.props;
      callIfPossible(onInputValueChange, evt);
      this.setState(Object.assign({}, getPaginationCache(this.props), {
        inputValue: evt.target.value
      }));
    };

    this.handlePaste = evt => {
      const {
        multi,
        onPaste
      } = this.props; // Allow developers to override default paste handling.

      callIfPossible(onPaste, evt);

      if (evt.defaultPrevented) {
        return;
      }

      if (!multi) return;
      const clipboardData = evt.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('Text');
      const splitValues = this.getSplitValuesFromString(pastedText, true);

      if (splitValues.length > 0) {
        evt.preventDefault();
        this.addMultiValues(splitValues);
      }
    };

    this.focus = () => {
      try {
        this._anchorRef.focus();
      } catch (e) {
        /* ¯\_(ツ)_/¯ */
      }
    };

    this.handleAutosize = () => {
      if (this.popoverRef.current) this.popoverRef.current.reposition();
    };

    this.dropdownContentRefCallback = dropdownEl => {
      if (dropdownEl) {
        dropdownEl.addEventListener('mousedown', this.handleMouseDownOnDropdown);
      }
    };

    this.virtualizedMenuRendererRefCallback = ref => {
      if (ref) {
        this._virtualizedMenuRenderer = ref;
      }
    };

    this.anchorRefCallback = anchorRef => {
      const {
        controlWidth,
        target
      } = this.state;
      this._anchorRef = anchorRef;
      const newTarget = findDOMNode(this._anchorRef);
      const newControlWidth = this.computeControlWidth(newTarget);

      if (target !== newTarget || controlWidth !== newControlWidth) {
        this.setState({
          controlWidth: newControlWidth,
          target: newTarget
        });
      }
    };

    this.selectRefCallback = () => {
      // Hackily override Select's selectValue and handleMouseDownOnMenu to support "Load more"
      const internalSelect = this.getInternalSelect();
      if (!internalSelect) return;
      internalSelect.selectValue = this.selectValueProxy.bind(this, internalSelect.selectValue);
      const internalCreatableSelect = this.getInternalCreatableSelect();
      if (!internalCreatableSelect) return;
      internalCreatableSelect.onInputChange = this.creatableOnInputChangeProxy;
    };

    this.getInternalSelect = () => {
      // Return our react-select Select instance, or null
      if (!this._anchorRef) {
        return null;
      }

      if (this._anchorRef.getInternalSelect) {
        return this._anchorRef.getInternalSelect();
      }

      return this._anchorRef.select || this._anchorRef;
    };

    this.getInternalCreatableSelect = () => {
      // Return our react-select Creatable instance, or null
      if (!this._anchorRef) {
        return null;
      }

      if (this._anchorRef.constructor === Creatable) {
        return this._anchorRef;
      }

      return null;
    };

    this.getInternalAsyncSelect = () => {
      // Return our react-select Async instance, or null
      if (!this._anchorRef) {
        return null;
      }

      if (this._anchorRef.getInternalAsyncSelect) {
        return this._anchorRef.getInternalAsyncSelect();
      }

      if (this._anchorRef.constructor === Async) {
        return this._anchorRef;
      }

      return null;
    };

    this.handleMouseDownOnDropdown = evt => {
      // react-select-plus normally closes the dropdown and blurs the input on mousedown. We need to
      // prevent that behavior for certain elements.
      const {
        target
      } = evt;

      if (closest(target, '.private-dropdown__footer-container')) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }

      if (closest(target, '.private-form__selectplus--load-more')) {
        this.triggerLoadMore();
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }

      if (closest(target, '.private-checkbox')) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }
    };

    this.loadOptionsProxy = (input, loadOptionsCallback) => {
      const {
        open,
        loadOptions
      } = this.props;

      if (input == null) {
        return;
      } // Show loading indicator until loadOptionsProxyCallback is called


      this.setState({
        isLoading: true
      });
      this._latestSearch = open ? input : null; // Special case: autoload search is designated as null
      // Keep a copy of all options returned by loadOptions

      const {
        paginationCache
      } = this.state;
      const proxyCallback = this.getLoadOptionsProxyCallback(open ? input : null, loadOptionsCallback);
      let result;

      try {
        result = loadOptions(input, proxyCallback, paginationCache[input || '']);
      } catch (error) {
        proxyCallback(error);
        setTimeout(() => {
          throw error;
        }, 0);
      }

      if (result && typeof result.then === 'function') {
        result.then(data => {
          proxyCallback(null, data || {});
        }, error => {
          proxyCallback(error);
          throw error;
        });
      }
    };

    this.checkForFormattedMessages = () => {
      const options = document.querySelectorAll('.Select-option>.private-typeahead-result');
      const optionLinks = Array.from(options).filter(item => item.querySelectorAll('a[href].private-link>i18n-string').length);
      if (optionLinks.length) return true;
      const optionsWithPopovers = document.querySelectorAll('.Select-option>.private-typeahead-result>[data-popover-id]');
      const popoverIds = Array.from(optionsWithPopovers).map(span => span.getAttribute('aria-describedby'));
      const popoverLinks = popoverIds.filter(popoverId => {
        return document.querySelectorAll(`#${popoverId} a[href].private-link>i18n-string`).length;
      });
      return !!popoverLinks.length;
    };

    this.renderDropdown = props => {
      const {
        closeOnTargetLeave,
        onOpenChange,
        open,
        placement
      } = this.props;
      return /*#__PURE__*/_jsx(UIControlledPopover, {
        arrowSize: "none",
        autoPlacement: "dropdown",
        closeOnTargetLeave: closeOnTargetLeave,
        content: this.renderDropdownContent(props),
        onOpenChange: onOpenChange,
        open: open,
        placement: placement || 'bottom right',
        popoverRef: this.popoverRef,
        target: this.state.target
      });
    };

    const cacheOptions = getOptionsCache(_props, this.state);

    const _resetOption = getResetOption(_props, this.state);

    this.state = Object.assign({}, this.state, {}, cacheOptions, {}, _resetOption, {
      initiallyOpen: _props.open,
      prevOpen: _props.open
    });
    this._isMounted = true; // not strictly true, but componentDidMount() fires too late!

    this._getInputProps = memoizeOne(getInputProps);
  }

  componentDidUpdate(prevProps) {
    const controlEl = findDOMNode(this._anchorRef);

    if (!controlEl) {
      return;
    }

    const controlWidth = this.computeControlWidth(controlEl);

    if (controlWidth !== this.state.controlWidth) {
      this.setState({
        controlWidth
      });
    }

    if (!prevProps.open && this.props.open) {
      this.focus();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  areOptionsToggleable({
    anchorType,
    multi
  }) {
    // Return true if we show options as checkboxes in the dropdown (#1976)
    const computedAnchorType = this.getAnchorType({
      anchorType,
      multi
    });
    return multi && computedAnchorType !== 'combined';
  }

  defaultOptionRenderer(option) {
    const {
      anchorType,
      itemComponent,
      multi,
      optionComponent,
      value
    } = this.props;
    const isOptionGroup = !!option.options;
    const isSelectAll = isOptionGroup && !!option.selectAll;
    const toggleable = this.areOptionsToggleable({
      anchorType,
      multi
    }) && option.className !== 'Select-create-option-placeholder' && !option.isSpecial && !(isOptionGroup && !isSelectAll);
    const {
      indeterminate,
      checked
    } = getCheckboxState(option, value);
    return /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
      itemComponent: optionComponent || itemComponent,
      isIndeterminate: toggleable && indeterminate,
      isSelected: toggleable && checked,
      onToggle: this.handleOptionToggle.bind(this, option),
      option: option,
      style: option.dropdownStyle,
      toggleable: toggleable,
      _useButton: !toggleable
    });
  }

  // Extracted to a function so it can be stubbed out in tests
  getDefaultFilterOptionsFunc() {
    return Select.defaultProps.filterOptions;
  }

  selectValueProxy(selectValue, selectedOption) {
    // If this is a "Load more" option, trigger load.
    if (selectedOption.value === loadMoreOptionValue) {
      this.triggerLoadMore();
    } // Prevent "special" options from being selected.


    if (selectedOption.isSpecial) {
      return;
    }

    selectValue(selectedOption);
  }

  triggerLoadMore() {
    // Trick Select.Async into calling loadOptions again, then move focus up one option
    const internalSelect = this.getInternalSelect();
    const internalAsyncSelect = this.getInternalAsyncSelect();

    if (!internalSelect || !internalAsyncSelect || !internalAsyncSelect.loadOptions) {
      return;
    }

    const {
      ignoreAccents,
      ignoreCase
    } = this.props;
    const visibleOptions = internalSelect._visibleOptions;
    const loadMoreOption = visibleOptions[visibleOptions.length - 1];
    const transformedInputValue = filterInputValue(loadMoreOption.input, {
      ignoreAccents,
      ignoreCase
    });

    if (internalAsyncSelect._cache) {
      delete internalAsyncSelect._cache[transformedInputValue];
    }

    internalAsyncSelect.loadOptions(transformedInputValue);
    const normalOptions = internalSelect.props.options;
    internalSelect.setState({
      focusedOption: normalOptions[normalOptions.length - 1]
    });
  }

  toggleGroup(groupToToggle, willBeSelected) {
    const {
      value
    } = this.props;
    const valueCopy = (value || []).slice(0);
    let newValue = valueCopy;

    if (willBeSelected) {
      const addOptionValue = o => {
        if (o.options) {
          o.options.filter(option => !option.disabled).forEach(addOptionValue);
        } else {
          if (newValue.indexOf(o.value) === -1) newValue.push(o.value);
        }
      };

      addOptionValue(groupToToggle);
    } else {
      const removeOptionValue = o => {
        if (o.options) {
          o.options.filter(option => !option.disabled).forEach(removeOptionValue);
        } else {
          newValue = newValue.filter(v => v !== o.value);
        }
      };

      removeOptionValue(groupToToggle);
    }

    this.setMultiValues(newValue);
  }

  toggleMultiValue(valueToToggle, willBeSelected) {
    const {
      value
    } = this.props;
    const valueCopy = (value || []).slice(0);
    let newValue = null;

    if (willBeSelected) {
      newValue = valueCopy.concat(valueToToggle);
    } else {
      newValue = valueCopy.filter(v => v !== valueToToggle);
    }

    this.setMultiValues(newValue);
  }

  addMultiValues(addValues) {
    const {
      value
    } = this.props;
    const newValues = (value || []).slice(0);
    addValues.forEach(v => {
      if (newValues.indexOf(v) === -1 && v !== '') newValues.push(v);
    });
    this.setMultiValues(newValues);
  }

  setMultiValues(newValues) {
    const {
      optionsCache
    } = this.state; // Map values to options

    const newOptions = newValues.map(v => optionsCache[v] || {
      text: v,
      value: v
    });
    this.handleChange(newOptions);
  }

  getSplitValuesFromString(str, includeLastValue) {
    const {
      allowCreate,
      splitRegex
    } = this.props;
    let strParts = str.split(splitRegex).map(s => s.trim());

    if (!includeLastValue) {
      strParts = strParts.slice(0, strParts.length - 1);
    }

    if (strParts.length === 0) return []; // Create a map of option labels to options

    const {
      optionsCache
    } = this.state;
    const reverseOptionsCache = {};
    Object.keys(optionsCache).forEach(key => {
      const option = optionsCache[key];
      reverseOptionsCache[option.text || key] = option.value;
    }); // For each piece, see if it maps to an option label. If so, add that option's value to
    // the result. Otherwise, if allowCreate is enabled, add a new option.

    const result = [];
    strParts.forEach(label => {
      if (reverseOptionsCache.hasOwnProperty(label)) {
        result.push(reverseOptionsCache[label]);
      } else if (allowCreate && result.indexOf(label) === -1) {
        result.push(label);
      }
    });
    return result;
  }

  getMenuWidth() {
    const {
      menuWidth
    } = this.props;

    if (menuWidth === 'auto') {
      return '';
    }

    if (typeof menuWidth === 'number') {
      return menuWidth;
    }

    return Math.max(this.state.controlWidth, MIN_MENU_WIDTH);
  }

  computeControlWidth(controlEl) {
    const {
      open
    } = this.props;

    if (!controlEl || !open) {
      return 0;
    }

    const exactWidth = controlEl.getBoundingClientRect().width;
    const roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
    return roundedWidth - 2; // account for 1px border added by UIPopover
  }

  getLoadOptionsProxyCallback(input, loadOptionsCallback) {
    const proxyCallback = (error, data, ...rest) => {
      if (!this._isMounted) return;
      const {
        optionsCache,
        paginationCache
      } = this.state;
      let newOptionsCache = optionsCache;
      let newPaginationCache = paginationCache; // Cache options so that we can render the selected value properly

      if (data && data.options) {
        newOptionsCache = makeNewOptionsCache(optionsCache, data.options);

        if (data.pagination) {
          newPaginationCache = Object.assign({}, paginationCache);
          newPaginationCache[input || ''] = data.pagination;
        }
      }

      const internalAsyncSelect = this.getInternalAsyncSelect();
      this.setState({
        isLoading: internalAsyncSelect && internalAsyncSelect._callback != null && this._latestSearch !== input,
        optionsCache: newOptionsCache,
        paginationCache: newPaginationCache
      });
      loadOptionsCallback(error, data, ...rest);
    };

    return proxyCallback;
  }

  getValueAsObject(value) {
    // In async mode, react-select needs the current value's object form to render it
    const {
      optionsCache
    } = this.state;

    if (!optionsCache) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(v => optionsCache.hasOwnProperty(v) ? optionsCache[v] : v);
    }

    return optionsCache.hasOwnProperty(value) ? optionsCache[value] : value;
  }

  isCollapsed({
    multi,
    multiCollapseLimit,
    open,
    value
  }) {
    return multiCollapseLimit != null && value != null && value.length > multiCollapseLimit && multi && !open;
  }

  getAnchorType({
    anchorType,
    multi
  }) {
    if (anchorType === 'auto') {
      return multi ? 'combined' : 'button';
    }

    return anchorType;
  }

  getNoResultsText({
    noResultsText
  }) {
    if (noResultsText != null) return lazyEval(noResultsText);
    const {
      inputValue
    } = this.state;
    return inputValue ? I18n.text('salesUI.UISelect.noResults') : I18n.text('salesUI.UISelect.typeToSearch');
  }

  getMenuRenderer({
    itemComponent,
    menuRenderer,
    menuWidth,
    optionRenderer,
    optionComponent
  }) {
    if (isVirtualized(menuRenderer)) {
      if (optionRenderer || itemComponent !== UISelectCore.defaultProps.itemComponent) {
        devLogger.warn({
          message: 'UISelect: virtualize cannot be used with optionRenderer or itemComponent',
          key: 'UISelect: virtualizeCustomRenderer'
        });
        return undefined;
      }

      if (menuWidth === 'auto') {
        devLogger.warn({
          message: 'UISelect: virtualize canot be used with menuWidth="auto"',
          key: 'UISelect: virtualizeAutoWidth'
        });
        return undefined;
      }

      return menuRenderer(this.getMenuWidth(), this.virtualizedMenuRendererRefCallback);
    }

    if (this.checkForFormattedMessages() && !hasShownDevWarning) {
      devLogger.warn({
        message: 'UISelect: Combining UILink and FormattedMessage inside of `react-select-plus` leads to broken links in any disabled options. Use a FormattedJSXMessage or I18n.text instead of FormattedMessage inside any UILink used in UISelect.',
        key: 'UISelect: FormattedMessage'
      });
      hasShownDevWarning = true;

      if (window.newrelic && !hasPingedNewRelic) {
        window.newrelic.addPageAction('ui-select-formatted-message', {
          component: itemComponent || optionComponent
        });
        hasPingedNewRelic = true;
      }
    }

    return menuRenderer;
  }

  renderDropdownContent(props) {
    const {
      dropdownClassName,
      loadOptions,
      menuRenderer,
      resultsClassName
    } = this.props;
    const className = classNames(dropdownClassName, 'private-dropdown__results', isVirtualized(menuRenderer) && 'private-dropdown--virtualized');
    return /*#__PURE__*/_jsx("span", {
      className: classNames('private-typeahead-results', resultsClassName),
      "data-dropdown-results": true,
      "data-async-options": !!loadOptions,
      children: /*#__PURE__*/_jsxs("div", {
        className: className,
        ref: this.dropdownContentRefCallback,
        style: {
          width: this.getMenuWidth()
        },
        children: [props.children, this.renderDropdownFooter()]
      })
    });
  }

  renderDropdownFooter() {
    const {
      dropdownFooter
    } = this.props;

    if (!dropdownFooter) {
      return null;
    }

    return /*#__PURE__*/_jsx("div", {
      className: "private-dropdown__footer-container",
      children: dropdownFooter
    });
  }

  renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest) {
    const {
      optionsCache
    } = this.state;
    const renderedValues = value.slice(0, multiCollapseLimit).map(v => {
      const option = optionsCache[v] || {
        text: v,
        value: v
      };
      const valueNode = (valueRenderer || this.defaultValueRenderer)(option);
      return /*#__PURE__*/_jsx(MultiSelectValue, {
        closeable: false,
        disabled: option.disabled,
        value: option,
        children: valueNode
      }, v);
    });
    const hiddenValueCount = value.length - renderedValues.length;
    const andMoreNode = hiddenValueCount > 0 ? /*#__PURE__*/_jsx(UIButton, {
      "data-hidden-value-count": hiddenValueCount,
      use: "transparent",
      children: I18n.text('salesUI.UISelect.plusMore', {
        count: hiddenValueCount
      })
    }) : null; // We use the same classnames as react-select here, to get the same appearance.

    return /*#__PURE__*/_jsx(UIClickable, Object.assign({}, getAriaAndDataProps(rest), {
      className: classNames('Select Select--multi', combinedAnchorClassName),
      "data-collapsed": true,
      onClick: this.triggerOpen,
      onFocus: this.triggerOpen,
      children: /*#__PURE__*/_jsxs("div", {
        className: "Select-control",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "Select-multi-value-wrapper",
          children: [renderedValues, andMoreNode]
        }), /*#__PURE__*/_jsx("div", {
          className: "Select-arrow-zone",
          children: /*#__PURE__*/_jsx("div", {
            className: "Select-arrow"
          })
        })]
      })
    }));
  }

  render() {
    const _this$props = this.props,
          {
      allowCreate,
      anchorType,
      autoComplete,
      autoFocus,
      ButtonContent,
      buttonContentProps,
      buttonSize,
      buttonUse,
      className,
      clearable,
      closeOnTargetLeave,
      disabled,
      error,
      id,
      ignoreAccents,
      ignoreCase,
      inputRef,
      inputValue,
      isLoading,
      itemComponent,
      loadOptions,
      menuRenderer,
      menuWidth,
      multi,
      multiCollapseLimit,
      noResultsText,
      onOpenChange,
      open,
      optionComponent,
      optionRenderer,
      options,
      placeholder,
      readOnly,
      resetValue,
      searchable,
      searchClassName,
      searchPlaceholder,
      searchPromptText,
      tabIndex,
      value,
      valueRenderer
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["allowCreate", "anchorType", "autoComplete", "autoFocus", "ButtonContent", "buttonContentProps", "buttonSize", "buttonUse", "className", "clearable", "closeOnTargetLeave", "disabled", "error", "id", "ignoreAccents", "ignoreCase", "inputRef", "inputValue", "isLoading", "itemComponent", "loadOptions", "menuRenderer", "menuWidth", "multi", "multiCollapseLimit", "noResultsText", "onChange", "onInputValueChange", "onOpenChange", "onSelectedOptionChange", "open", "optionComponent", "optionRenderer", "options", "placeholder", "readOnly", "resetValue", "searchable", "searchClassName", "searchPlaceholder", "searchPromptText", "splitRegex", "tabIndex", "value", "valueComponent", "valueRenderer"]);

    const {
      initiallyOpen,
      resetOption
    } = this.state;
    const combinedAnchorClassName = classNames(className, 'private-form__selectplus', multi && 'private-form__selectplus--multi', error && 'private-form__control--error', readOnly && 'is-readonly'); // Use an HOC around React Select, if applicable

    let SelectComponent = Select;

    if (loadOptions) {
      SelectComponent = Select.Async;
    } else if (allowCreate) {
      SelectComponent = Select.Creatable;
    } // Use the virtualizedMenuRenderer, if it's provided and compatible with the other props


    const computedMenuRenderer = this.getMenuRenderer({
      itemComponent,
      menuRenderer,
      menuWidth,
      optionRenderer,
      optionComponent
    }); // Determine what type of control the dropdown is attached to

    const computedAnchorType = this.getAnchorType({
      anchorType,
      multi
    }); // A null or undefined value should be considered equivalent to resetValue

    const computedValue = value == null ? resetValue : value;

    if (loadOptions && allowCreate) {
      devLogger.warn({
        message: 'UISelect: loadOptions and allowCreate are mutually exclusive.',
        key: 'UISelect: asyncCreatable'
      });
    }

    if (rest.autofocus) {
      devLogger.warn({
        message: "UISelect: The autofocus prop is deprecated in favor of autoFocus to match React's autoFocus prop",
        key: 'UISelect: autofocus'
      });
    }

    if (inputRef && computedAnchorType === 'combined') {
      devLogger.warn({
        message: 'UISelect: The inputRef prop is only supported with anchorType="input" or anchorType="button"',
        key: 'UISelect: inputRef'
      });
    } // We need to attach two ref callbacks to the combined anchor.


    this._refSequence = this._refSequence || sequence(this.anchorRefCallback, this.selectRefCallback); // Bootstrap a read-only state on the "external" Select component by disabling interactivity
    // Only needed for the "combined" anchorType - readOnly class prevents disabled styles from being applied

    const readOnlyProps = readOnly ? {
      disabled: true
    } : {};
    return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
      children: ({
        disabled: fieldDisabled,
        size: fieldSize
      }) => {
        const computedDisabled = disabled || fieldDisabled; // Props that are used regardless of anchor type

        const commonProps = Object.assign({}, rest, {
          backspaceRemoves: multi && computedAnchorType === 'combined',
          clearable: computedAnchorType === 'combined' ? clearable : false,
          disabled: computedDisabled,
          filterOptions: this.filterOptionsProxy,
          id,
          ignoreAccents,
          ignoreCase,
          inputProps: this._getInputProps(autoComplete, computedDisabled, id, searchable, computedAnchorType, this.handleAutosize, this.handlePaste, readOnly),
          isLoading: isLoading != null ? isLoading : this.state.isLoading,
          isOpen: open && !readOnly && !!this.state.target,
          labelKey: 'text',
          loadOptions: loadOptions ? this.loadOptionsProxy : undefined,
          loadingPlaceholder: null,
          menuRenderer: computedMenuRenderer,
          multi,
          noResultsText: this.getNoResultsText({
            noResultsText
          }),
          onChange: this.handleChange,
          onClose: this.handleClose,
          onInputChange: this.handleInputChange,
          onInputKeyDown: this.handleInputKeyDown,
          onOpen: this.handleOpen,
          onPaste: this.handlePaste,
          openAfterFocus: true,
          optionRenderer: this.optionRendererProxy,
          options: loadOptions ? undefined : options,
          placeholder: lazyEval(placeholder),
          readOnly,
          ref: this.anchorRefCallback,
          renderInvalidValues: true,
          required: false,
          resetValue,
          searchable,
          searchPromptText: lazyEval(searchPromptText),
          tabIndex,
          tabSelectsValue: false,
          value: loadOptions ? this.getValueAsObject(computedValue) : computedValue,
          valueComponent: multi ? MultiSelectValue : Select.defaultProps.valueComponent,
          valueRenderer: valueRenderer || this.defaultValueRenderer
        });
        const simpleAnchorClassName = classNames(className, SELECT_SIZE_OPTIONS[fieldSize], error && 'private-form__control--error');

        if (computedAnchorType === 'input') {
          return /*#__PURE__*/_jsx(UISelectWithInputAnchor, Object.assign({}, commonProps, {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            className: simpleAnchorClassName,
            dropdownComponent: this.renderDropdown,
            error: error,
            inputRef: inputRef,
            inputValue: inputValue,
            onInputValueChange: this.handleInputValueChange,
            onOpenChange: onOpenChange,
            selectComponent: SelectComponent,
            selectRef: this.selectRefCallback
          }));
        }

        if (this.isCollapsed({
          multi,
          multiCollapseLimit,
          open,
          value
        })) {
          return this.renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest);
        }

        if (computedAnchorType === 'button') {
          return /*#__PURE__*/_jsx(UISelectWithButtonAnchor, Object.assign({}, commonProps, {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            buttonSize: buttonSize,
            ButtonContent: ButtonContent,
            buttonContentProps: buttonContentProps,
            buttonUse: buttonUse,
            className: simpleAnchorClassName,
            closeOnTargetLeave: closeOnTargetLeave,
            dropdownContentRef: this.dropdownContentRefCallback,
            dropdownFooter: this.renderDropdownFooter(),
            error: error,
            initiallyOpen: initiallyOpen,
            inputRef: inputRef,
            menuWidth: menuWidth,
            onInputValueChange: this.handleInputValueChange,
            onOpenChange: onOpenChange,
            resetOption: resetOption,
            searchClassName: searchClassName,
            searchPlaceholder: lazyEval(searchPlaceholder),
            selectComponent: SelectComponent,
            selectRef: this.selectRefCallback
          }));
        }

        return /*#__PURE__*/_jsx(SelectComponent, Object.assign({
          autofocus: autoFocus
        }, commonProps, {
          className: combinedAnchorClassName,
          dropdownComponent: this.renderDropdown,
          ref: this._refSequence,
          tabIndex: typeof tabIndex === 'number' ? String(tabIndex) : tabIndex
        }, readOnlyProps));
      }
    });
  }

}

UISelectCore.propTypes = {
  /**
   * Shows a prompt to create a new option when the user enters a query that
   * doesn’t match any existing option.
   */
  allowCreate: PropTypes.bool,

  /**
   * Determines the type of component to use as the base for the select. The
   * `"input"` base renders as a searchable text input, while the `"button"`
   * base renders as a button. `"combined"` is a mix of both text input and
   * button features with an input-like affordance. `"auto"` defaults to
   * `"combined"` for multi-selects and `"button"` for single selects. `"input"`
   * cannot be used with multi-selects due to usability issues; use
   * `"combined"` instead.
   */
  anchorType: PropTypes.oneOf(['auto', 'button', 'combined', 'input']),

  /**
   * When the HTML `autoComplete` attribute is `"off"`, it prevents the
   * browser's own select from appearing over the component's dropdown. Works
   * with `anchorType="combined"` selects only.
   */
  autoComplete: PropTypes.string,

  /**
   * Auto-focuses on the select input on render.
   */
  autoFocus: PropTypes.bool,

  /**
   * Determines if a call to `loadOptions` should occur when the search string
   * is empty.
   */
  autoload: PropTypes.bool,

  /**
   * Provide a custom button component to render if `anchorType="button"`. The
   * component is passed a `buttonText` prop. Props do not need to be spread to this component.
   */
  ButtonContent: UISelectWithButtonAnchor.propTypes.ButtonContent,

  /**
   * Provide extra props to the `ButtonContent` component. This helps to avoid
   * need for declaring `ButtonContent` inside another component.
   */
  buttonContentProps: PropTypes.object,

  /**
   * Sets the size of the button used for the anchor of the component,
   * corresponding to `UIButton` sizes. Only used when `anchorType="button"`.
   */
  buttonSize: UIButton.propTypes.size,

  /**
   * Sets the visual styles of the button used for the anchor of the component,
   * corresponding to `UIButton` uses. Only used when `anchorType="button"`.
   */
  buttonUse: UIButton.propTypes.use,

  /**
   * Sets the cache object used for options. Alternatively, set to `false` if
   * you’d like to disable caching.
   */
  cache: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Provide a custom component to be used to render the caret that appears
   * inside the dropdown button. The component is passed the corresponding
   * `buttonUse` prop. Only used when `anchorType="button"`.
   */
  caretRenderer: UISelectWithButtonAnchor.propTypes.caretRenderer,

  /**
   * Provides an affordance to clear the current value of the select. When used
   * with `anchorType="combined"` an "X" is shown on the input, otherwise the
   * placeholder value is added as an option to clear the select.
   */
  clearable: PropTypes.bool.isRequired,

  /**
   * Automatically triggers a close event for the option menu if the select
   * anchor is scrolled out of view.
   */
  closeOnTargetLeave: PropTypes.bool,

  /**
   * Determines whether the option menu is open by default. The `open` prop takes
   * precedence over this if used in a controlled manner.
   */
  defaultOpen: PropTypes.bool,

  /**
   * The `value` to use for initial selection of an option.
   */
  defaultValue: ValueType,

  /**
   * When this character is included within a `defaultValue` or `value` string,
   * the value will split at the delimiter. For example,
   * `defaultValue="hey;there"` will render as two separate options, "hey" and
   * "there", in a multi-select.
   */
  delimiter: PropTypes.string.isRequired,

  /**
   * Determines if the select input is disabled.
   */
  disabled: PropTypes.bool,

  /**
   * A custom className to pass to the container of the dropdown option menu.
   */
  dropdownClassName: PropTypes.string,

  /**
   * Content that will be shown at the bottom of the select dropdown; most
   * commonly used for an “Add option” button that opens a popover with input
   * fields to gather more information for the option creation.
   */
  dropdownFooter: PropTypes.node,

  /**
   * When `true`, shows an error affordance around the select input.
   * `UIFormControl` should be used around the select to add inline error
   * messaging.
   */
  error: PropTypes.bool,

  /**
   * Provides custom functionality to replace the method used to filter options.
   * Accepts a boolean or a callback function that returns a list of options.
   * The callback function expects the following parameters: `options`, `filterValue`, `excludeOptions`, and `props`.
   * The parameter `options` is the array of options. The option that contains `filterValue` in its `text` or `value` property
   * will be included in the returned array of options. The parameter `excludeOptions` is the array of options to exclude from
   * the returned array of options. The  parameter `props` is an object with the following filtering options:
   * `filterOption`, `ignoreAccents`, `ignoreCase`, `labelKey`, `matchPos`, `matchProp`, and `valueKey`.
   * Descriptions of these filtering options can be found in
   * the [HubSpot/react-select-plus docs](https://github.com/HubSpot/react-select-plus#filtering-options).
   */
  filterOptions: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

  /**
   * An id that is passed to the computed anchor element. Works with
   * `anchorType="button"` or `anchorType="combined"`.
   */
  id: PropTypes.string,

  /**
   * Ignores accented characters and replaces them with the base character.
   */
  ignoreAccents: hidden(PropTypes.bool),

  /**
   * When enabled, search strings are matched to options case-insensitively.
   */
  ignoreCase: hidden(PropTypes.bool),

  /**
   * Provide a custom input component to use as the anchor component. Only used
   * when `anchorType="input"`.
   */
  inputComponent: PropTypes.elementType,

  /**
   * Set a `ref` to the underlying input component.
   */
  inputRef: refObject,

  /**
   * Controls the value of the underlying input. Only used when
   * `anchorType="input"`.
   */
  inputValue: PropTypes.string,

  /**
   * Shows a loading spinner at the end of the options menu.
   */
  isLoading: PropTypes.bool,

  /**
   * The component used to render an option in both the dropdown list and the
   * selected value box. Receives the option object as a prop, along with
   * several other props that should get routed to the root element of the
   * `itemComponent`. The `optionComponent` prop overrides this prop's value
   * for rendering options in the dropdown list, and the `valueComponent` prop
   * overrides this prop's value for rendering options in the selected value box.
   */
  itemComponent: UITypeaheadResultsItem.propTypes.itemComponent,

  /**
   * Provide a custom component that prompts the user to load more options in a
   * paginated select.
   */
  loadMoreComponent: customRenderer.propType,

  /**
   * Provide a custom function that asynchronously loads options.
   */
  loadOptions: PropTypes.func,

  /**
   * Provide a custom function to render the options menu, typically used for
   * virtualized menu rendering. Ordinarily set to `UIComponents/input/utils/virtualizedMenuRenderer`, a react-virtualized function which
   * accepts a number of named parameters.
   */
  menuRenderer: PropTypes.func,

  /**
   * A style object to be applied to the options menu.
   */
  menuStyle: PropTypes.object,

  /**
   * Sets a custom width on the dropdown menu.
   */
  menuWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),

  /**
   * The minimum number of options required before the search input appears in
   * the dropdown.
   */
  minimumSearchCount: PropTypes.number,

  /**
   * Whether multiple options can be selected.
   */
  multi: PropTypes.bool.isRequired,

  /**
   * Defines the max amount of selected options that can appear in the closed
   * state. Only works for `multi={true}`.
   */
  multiCollapseLimit: PropTypes.number,

  /**
   * Text shown when there are no results for given search term within the
   * select.
   */
  noResultsText: createLazyPropType(PropTypes.node),

  /**
   * Provides a custom function that is called whenever the value of the select
   * changes.
   */
  onChange: PropTypes.func,

  /**
   * Triggered whenever a key is pressed when there’s focus on an open select
   * (including arrow keys, shift, etc).
   */
  onInputKeyDown: PropTypes.func,

  /**
   * Triggered whenever the search value has changed or an option has been
   * selected (even if it’s the same option).
   */
  onInputChange: PropTypes.func,

  /**
   * Triggered whenever the search value has changed.
   */
  onInputValueChange: PropTypes.func,

  /**
   * A function to call whenever the select’s menu open state changes.
   */
  onOpenChange: PropTypes.func,

  /**
   * A function to call whenever a value is pasted into the select. The pasted
   * value can be accessed from the clipboardData field on the event object.
   */
  onPaste: PropTypes.func,

  /**
   * Triggered whenever an option is selected. This event fires even if the
   * same option is selected, unlike `onChange`.
   */
  onSelectedOptionChange: PropTypes.func,

  /**
   * Controls the open state of the option menu.
   */
  open: PropTypes.bool,

  /**
   * The component used to render an option in the dropdown list. Receives the
   * option object as a prop, along with several other props that should get
   * routed to the root element of the `optionComponent`. Defaults to the value
   * of the `itemComponent` prop.
   */
  optionComponent: UITypeaheadResultsItem.propTypes.itemComponent,

  /**
   * The options from which the user may select from. In most cases, each
   * option object must have a `text` key, which controls the display text
   * and is used in search, and a `value` key.
   */
  options: PropTypes.arrayOf(OptionOrGroupType),

  /**
   * Provide a custom function that is responsible for rendering each option.
   * Receives an option object as its arguments.
   */
  optionRenderer: PropTypes.func,

  /**
   * When enabled, options that have a truthy `isSpecial` key are rendered
   * using the default option renderer instead of the passed optionRenderer
   * prop.
   */
  optionRendererIgnoresSpecialOptions: PropTypes.bool,

  /**
   * The placeholder text in the select. This also becomes the text that allows
   * a user to clear the current selected option when used with clearable
   * `anchorType="button"|"input"`.
   */
  placeholder: createLazyPropType(PropTypes.node).isRequired,

  /**
   * Controls the placement of the option menu popover.
   */
  placement: PropTypes.oneOf(PLACEMENTS),

  /**
   * A function that returns custom text for prompting the user to create a new
   * option. The new option’s `text` value is passed through as the function
   * argument. Only used with `allowCreate={true}`.
   */
  promptTextCreator: PropTypes.func,

  /**
   * Determines if the select input is read-only or editable.
   */
  readOnly: PropTypes.bool,

  /**
   * The value set when the user clears the select input. Only possible when
   * `clearable={true}`.
   */
  resetValue: ValueType,

  /**
   * A custom className to pass to the container of the list of displayed
   * options inside of the popover.
   */
  resultsClassName: PropTypes.string,

  /**
   * Whether or not the search input is visible. Note that in the current
   * behavior, the select still always filters when typing in the input.
   */
  searchable: PropTypes.bool.isRequired,

  /**
   * ClassName passed to the search input within the select.
   */
  searchClassName: PropTypes.string,

  /**
   * Placeholder text in the search input within the select.
   */
  searchPlaceholder: createLazyPropType(PropTypes.string).isRequired,

  /**
   * Text to display when options have not been fetched yet by `loadOptions`.
   */
  searchPromptText: createLazyPropType(PropTypes.string).isRequired,

  /**
   * A regex string to define the delimiter(s) between options for
   * multi-selects.
   */
  splitRegex: PropTypes.object,

  /**
   * Sets a custom value for `tabIndex` on the rendered anchor element.
   */
  tabIndex: PropTypes.number,

  /**
   * Controls the current value of the select. For `anchorType="input"`, use
   * `inputValue` instead.
   */
  value: ValueType,

  /**
   * The component used to render the options in the selected value box.
   * Receives the option object as a prop, along with several other props that
   * should get routed to the root element of the `valueComponent`. Defaults to
   * the value of the `itemComponent` prop.
   */
  valueComponent: UITypeaheadResultsItem.propTypes.itemComponent,

  /**
   * Provide a custom function that is responsible for rendering the current
   * value of the select, shown in the anchor input or button.
   */
  valueRenderer: PropTypes.func,

  /**
   * Forces the placeholder to be shown even if the select has a current value.
   * Presumably used with anchorType="button" and buttonUse to mimic dropdown
   * behavior.
   */
  _forcePlaceholder: PropTypes.bool
};
UISelectCore.defaultProps = {
  allowCreate: false,
  anchorType: 'auto',
  autoComplete: 'off',
  autoload: true,
  buttonSize: 'default',
  buttonUse: 'form',
  clearable: false,
  delimiter: ';',
  open: false,
  ignoreAccents: true,
  ignoreCase: true,
  inputComponent: UISearchInput,
  itemComponent: 'span',
  loadMoreComponent: LoadMoreComponent,
  minimumSearchCount: 8,
  multi: false,
  optionRendererIgnoresSpecialOptions: false,
  placeholder: () => I18n.text('salesUI.UISelect.placeholder'),
  promptTextCreator,
  resetValue: '',
  searchable: true,
  searchPlaceholder: () => I18n.text('salesUI.UISearchableSelectInput.placeholder'),
  searchPromptText: () => I18n.text('salesUI.UISelect.typeToSearch'),
  splitRegex: /;/,
  value: '',
  _forcePlaceholder: false
};
UISelectCore.displayName = 'UISelect';
const UISelect = Controllable(UISelectCore, ['open', 'value']);
UISelect.stripDiacritics = stripDiacritics;
export default UISelect;